"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _AssociationsStore = _interopRequireDefault(require("crm_data/associations/AssociationsStore"));

var _CompaniesChildrenStore = _interopRequireDefault(require("crm_data/companies/CompaniesChildrenStore"));

var _DealPipelineStore = _interopRequireDefault(require("crm_data/deals/DealPipelineStore"));

var _DoubleOptInStore = _interopRequireDefault(require("crm_data/email/DoubleOptInStore"));

var _EmailUnbounceStore = _interopRequireDefault(require("crm_data/email/EmailUnbounceStore"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var MetaAPI = _interopRequireWildcard(require("crm_data/meta/MetaAPI"));

var _ObjectsActions = _interopRequireDefault(require("crm_data/objects/ObjectsActions"));

var _PortalFavoritesStore = _interopRequireDefault(require("crm_data/properties/PortalFavoritesStore"));

var _PropertyGroupsStore = _interopRequireDefault(require("crm_data/properties/PropertyGroupsStore"));

var _UserFavoritesStore = _interopRequireDefault(require("crm_data/properties/UserFavoritesStore"));

var _QueuesStore = _interopRequireDefault(require("crm_data/queues/QueuesStore"));

var _SFDCMetadataStore = _interopRequireDefault(require("crm_data/sfdc/SFDCMetadataStore"));

var _TicketsPipelinesStore = _interopRequireDefault(require("crm_data/tickets/TicketsPipelinesStore"));

var _VidyardStore = _interopRequireDefault(require("crm_ui/extensions/vidyard/VidyardStore"));

var _ErrorPage = _interopRequireDefault(require("crm_ui/error/ErrorPage"));

var _connectRecordOnboarding = _interopRequireDefault(require("crm_ui/onboarding/connectRecordOnboarding"));

var _RoutedProfilePermissionsContainer = _interopRequireDefault(require("crm_ui/permissions/RoutedProfilePermissionsContainer"));

var _PinnedEngagementsStore = _interopRequireDefault(require("crm_ui/pinnedEngagements/stores/PinnedEngagementsStore"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _SequenceEnrollmentStore = _interopRequireDefault(require("crm_ui/flux/sequences/SequenceEnrollmentStore"));

var _PageLoadModalLauncherAsync = _interopRequireDefault(require("crm_ui/onboarding/PageLoadModalLauncherAsync"));

var _logProfileMountTiming = _interopRequireDefault(require("crm_ui/utils/logProfileMountTiming"));

var _immutable = require("immutable");

var _Raven = _interopRequireDefault(require("Raven"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _Profile = _interopRequireDefault(require("./Profile"));

var _AssociatedOpenObjectsStore = _interopRequireDefault(require("crm_ui/engagementAssociations/AssociatedOpenObjectsStore"));

var _TeamsStore = _interopRequireDefault(require("crm_data/teams/TeamsStore"));

var _FollowStore = _interopRequireDefault(require("crm_ui/follow/FollowStore"));

var _TimelineFetchingActions = require("crm_data/timeline/TimelineFetchingActions");

var _TimelineFiltersStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFiltersStore"));

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _UserSettingsAPI = require("crm_data/settings/UserSettingsAPI");

var _delayUntilIdle = require("crm_ui/utils/delayUntilIdle");

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _reactCommon = require("@apollo/react-common");

var _client = require("customer-data-sidebar/graphQL/client");

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _PropertySourceContext = require("crm_ui/profile/PropertySourceContext");

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _getIsUngatedForGraphQL = require("crm_ui/gates/getIsUngatedForGraphQL");

require("crm_ui/timeline/data/services/TimelineFetchingService");

require("crm_ui/timeline/data/stores/TimelineMonthsStore");

require("crm_ui/timeline/data/stores/TimelineEventsStore");

require("crm_ui/timeline/data/stores/TimelineStatusStore");

// TODO: fix these https://git.hubteam.com/HubSpot/CRM-Issues/issues/1874
var FAILURE_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  ALL: 'ALL',
  PARSE: 'PARSE'
};

var getAssociationTypes = function getAssociationTypes(currentObjectType, currentObjectId) {
  var result = [];
  [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL, _ObjectTypes.TICKET].forEach(function (objectType) {
    if (objectType === currentObjectType) {
      return;
    }

    result.push({
      objectType: currentObjectType,
      objectId: currentObjectId,
      associationType: currentObjectType + "_TO_" + objectType
    });
  });

  if (currentObjectType === _ObjectTypes.DEAL) {
    result.push({
      objectType: currentObjectType,
      objectId: currentObjectId,
      associationType: _AssociationTypes.DEAL_TO_LINE_ITEM
    });
    result.push({
      objectType: currentObjectType,
      objectId: currentObjectId,
      associationType: _AssociationTypes.DEAL_TO_QUOTE
    });
  }

  return result;
};

var getOpenObjectsKeys = function getOpenObjectsKeys(objectType, subjectId) {
  return [_ObjectTypes.DEAL, _ObjectTypes.TICKET].map(function (objectTypeToFetch) {
    return (0, _immutable.Map)({
      objectType: objectType,
      subjectId: subjectId,
      objectTypeToFetch: objectTypeToFetch
    });
  });
};

var getFailureFunc = function getFailureFunc(failureType) {
  return function (_ref) {
    var type = _ref.type,
        options = _ref.options,
        requestFailureType = _ref.requestFailureType;
    var failureTypeString = failureType;

    if (failureType === FAILURE_TYPES.INDIVIDUAL) {
      failureTypeString = type;
    }

    if (window.newrelic != null) {
      window.newrelic.setCustomAttribute('crmMeta-failure-type', failureTypeString);
    }

    return _Raven.default.captureMessage("crm-meta failure: " + failureTypeString, {
      extra: {
        type: type,
        options: options,
        requestFailureType: requestFailureType
      }
    });
  };
};

MetaAPI.setOnFailure(getFailureFunc(FAILURE_TYPES.INDIVIDUAL));
MetaAPI.setOnAllFailure(getFailureFunc(FAILURE_TYPES.ALL));
MetaAPI.setOnParseError(getFailureFunc(FAILURE_TYPES.PARSE));

var fetchInitialTimelineEvents = function fetchInitialTimelineEvents(objectType, subjectId) {
  return (0, _TimelineFetchingActions.fetchInitialActivities)((0, _immutable.fromJS)({
    subjectId: subjectId,
    objectType: objectType,
    TIMELINE_ITEM_LIMIT: 5,
    fromDate: null,
    toDate: null
  }));
};

var preloadMetaAPI = function preloadMetaAPI(objectType, subjectId) {
  _PinnedEngagementsStore.default.get((0, _immutable.Map)({
    objectType: objectType,
    subjectId: subjectId
  }));

  _PropertyGroupsStore.default.get(objectType);

  _PortalFavoritesStore.default.get(objectType);

  _UserFavoritesStore.default.get(objectType);

  _QueuesStore.default.get();

  _DoubleOptInStore.default.get();

  _SFDCMetadataStore.default.get();

  _AssociationsStore.default.get(getAssociationTypes(objectType, subjectId));

  _DealPipelineStore.default.get();

  _TicketsPipelinesStore.default.get();

  _TeamsStore.default.get();

  _FollowStore.default.get((0, _immutable.Map)({
    objectType: objectType,
    subjectId: subjectId
  }));

  _VidyardStore.default.get();

  if (objectType === _ObjectTypes.CONTACT) {
    subjectId = parseInt(subjectId, 10);

    _SequenceEnrollmentStore.default.get(subjectId);

    _EmailUnbounceStore.default.get(subjectId);

    _AssociatedOpenObjectsStore.default.get(getOpenObjectsKeys(objectType, String(subjectId)));
  } else if (objectType === _ObjectTypes.COMPANY) {
    _CompaniesChildrenStore.default.get(subjectId);

    _AssociatedOpenObjectsStore.default.get(getOpenObjectsKeys(objectType, String(subjectId)));
  }
};

function preloadTimeline(objectType, subjectId) {
  _TimelineFiltersStore.default.get(objectType);

  fetchInitialTimelineEvents(objectType, subjectId);
}

var ProfileContainer = (0, _createReactClass.default)({
  displayName: 'ProfileContainer',
  getInitialState: function getInitialState() {
    return {
      propertySourceInfo: undefined
    };
  },
  componentWillMount: function componentWillMount() {
    var earlyThreeColumnRequest = window.quickFetch && window.quickFetch.getRequestStateByName('threeColumn');

    if (earlyThreeColumnRequest) {
      earlyThreeColumnRequest.whenFinished(function (resp) {
        (0, _Dispatch.dispatchQueue)('USERSETTINGS_FETCH_SUCCEEDED', (0, _UserSettingsAPI.normalizeUserSettingsResponse)(resp));
        window.quickFetch.removeEarlyRequest('threeColumn');
      });
    }
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var _this$props = this.props,
        subjectId = _this$props.subjectId,
        objectType = _this$props.objectType;
    (0, _logProfileMountTiming.default)();
    var isUngatedForGraphQL = (0, _getIsUngatedForGraphQL.getIsUngatedForGraphQL)(objectType);

    if (!isUngatedForGraphQL) {
      MetaAPI.enable();
      preloadMetaAPI(objectType, subjectId);
    }

    preloadTimeline(objectType, subjectId);

    if (window.newrelic != null) {
      window.newrelic.setCustomAttribute('crmMetaForAll', true);
    }

    if (!isUngatedForGraphQL) {
      _ObjectsActions.default.refresh(objectType, subjectId);
    }

    (0, _userInfo.default)().then(function (user) {
      _this.setState({
        propertySourceInfo: {
          propertySourceId: (0, _getIn.default)(['user', 'email'], user),
          propertySource: _PropertySourceTypes.CRM_UI
        }
      });
    });

    if (!_CurrentOwnerContainer.default.isJitaUser) {
      (0, _delayUntilIdle.delayUntilIdle)(function () {
        (0, _PageLoadModalLauncherAsync.default)().then(function (PageLoadModalLauncher) {
          return PageLoadModalLauncher.maybeShowModal();
        });
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(_ref2, _ref3) {
    var canViewProfile = _ref2.canViewProfile,
        subjectId = _ref2.subjectId,
        query = _ref2.query;
    var propertySourceInfo = _ref3.propertySourceInfo;
    return (0, _LoadingStatus.isLoading)(this.props.canViewProfile) !== (0, _LoadingStatus.isLoading)(canViewProfile) || this.props.subjectId !== subjectId || this.props.query !== query || this.state.propertySourceInfo !== propertySourceInfo;
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        objectType = _this$props2.objectType,
        subjectId = _this$props2.subjectId;

    if (subjectId !== prevProps.subjectId) {
      fetchInitialTimelineEvents(objectType, subjectId);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    MetaAPI.disable();
  },
  render: function render() {
    var _this$props3 = this.props,
        objectType = _this$props3.objectType,
        subjectId = _this$props3.subjectId,
        query = _this$props3.query,
        canViewProfile = _this$props3.canViewProfile;

    if (!canViewProfile && !(0, _LoadingStatus.isLoading)(canViewProfile)) {
      return _react.default.createElement(_ErrorPage.default, {
        errorCode: "403",
        objectType: objectType
      });
    }

    var key = objectType + subjectId + (query && query.taskId || '') + (query && query._t || '');
    return _react.default.createElement(_SubjectContext.SubjectContext.Provider, {
      value: (0, _SubjectContext.SubjectData)({
        objectType: objectType,
        subjectId: String(subjectId)
      })
    }, _react.default.createElement(_PropertySourceContext.PropertySourceContext.Provider, {
      value: this.state.propertySourceInfo
    }, _react.default.createElement(_reactCommon.ApolloProvider, {
      client: _client.client
    }, _react.default.createElement(_Profile.default, (0, _extends2.default)({}, this.props, {
      key: key
    })))));
  }
});

var _default = (0, _RoutedProfilePermissionsContainer.default)((0, _connectRecordOnboarding.default)(ProfileContainer));

exports.default = _default;
module.exports = exports.default;